import { createFileRoute } from "@tanstack/react-router";
import { format, isWeekend, subDays } from "date-fns";
import { getPriceUpdateDataByDatePriceUpdateGet } from "@/client-admin";
import { ReviewPriceUploadData } from "@/components/PriceUpdate/ReviewPriceUploadData";
import { checkSuperUserPermission } from "@/lib/utils";

export function getPreviousWorkDay(from: Date = new Date()): Date {
  let date = subDays(from, 1);
  while (isWeekend(date)) {
    date = subDays(date, 1);
  }
  return date;
}

export const Route = createFileRoute("/_superuser/admin/price-update/review-upload")({
  beforeLoad: () => {
    checkSuperUserPermission("price-update");
  },
  loader: async () => {
    const today = format(new Date(), "yyyy-MM-dd");
    return getPriceUpdateDataByDatePriceUpdateGet({
      date: today,
    });
  },
  component: ReviewUploadComponent,
});

function ReviewUploadComponent() {
  const routeData = Route.useLoaderData();
  return <ReviewPriceUploadData getPriceUpdateResponse={routeData} />;
}
